import { render } from "./confirmModal.vue?vue&type=template&id=12cef418&scoped=true&ts=true"
import script from "./confirmModal.vue?vue&type=script&lang=ts"
export * from "./confirmModal.vue?vue&type=script&lang=ts"

import "./confirmModal.vue?vue&type=style&index=0&id=12cef418&scoped=true&lang=css"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cef418"]])

export default __exports__